import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Proof() {
  return <section className="py-12 md:py-14 bg-brand-cream bg-noise" data-id="element-343">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-4xl" data-id="element-344">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative bg-white p-10 md:p-16 rounded-3xl shadow-xl border border-brand-gold/10 text-center" data-id="element-345">
          <Quote className="absolute top-8 left-8 w-12 h-12 text-brand-gold/20 rotate-180" data-id="element-346" />
          <Quote className="absolute bottom-8 right-8 w-12 h-12 text-brand-gold/20" data-id="element-347" />

          <p className="text-2xl md:text-3xl font-serif font-medium text-brand-navy leading-relaxed relative z-10" data-id="element-348">
            "En solo 7 días, pasarás de sentir que el cierre de tu jeans no sube
            a despertar con una ligereza abdominal que no sentías desde los 30.{' '}
            <span className="text-brand-gold font-bold" data-id="element-349">
              No es magia, es ciencia aplicada a la despensa de tu casa.
            </span>
            "
          </p>
        </motion.div>
      </div>
    </section>;
}